import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Our Work", href: "#work" },
  { label: "FAQ", href: "#faq" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0F172A] border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24 lg:h-28">
          <a href="#home" className="flex items-center gap-3" data-testid="nav-logo-link">
            <img src="/assets/aegis-logo-dark.webp" alt="Aegis Subsurface LLC logo" className="h-20 lg:h-24 w-auto" />
          </a>

          <nav className="hidden lg:flex items-center gap-6" data-testid="nav-desktop">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                className="nav-link-underline text-sm font-semibold uppercase tracking-wider text-slate-300 hover:text-[#FF5A00] transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+18326611121"
              data-testid="nav-call-button"
              className="flex items-center gap-2 text-base font-bold whitespace-nowrap text-[#FF5A00] hover:text-white transition-colors duration-200 ml-6"
            >
              <Phone className="w-5 h-5" />
              (832) 661-1121
            </a>
          </nav>

          <div className="hidden lg:block" aria-hidden="true" />

          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0F172A] border-t border-white/10" data-testid="nav-mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(" ", "-")}`}
                className="text-sm font-semibold uppercase tracking-wider text-slate-300 hover:text-[#FF5A00] py-3 border-b border-white/5 transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-quote-button"
              className="mt-3 bg-[#FF5A00] text-white text-center text-sm font-bold uppercase tracking-wider px-5 py-3 rounded-sm"
            >
              Request a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
